import bnLcvRouteLanding from "../../../../core/src/locales/bn/lcvRouteLanding.json";
import enLcvRouteLanding from "../../../../core/src/locales/en/lcvRouteLanding.json";
import guLcvRouteLanding from "../../../../core/src/locales/gu/lcvRouteLanding.json";
import hiLcvRouteLanding from "../../../../core/src/locales/hi/lcvRouteLanding.json";
import knLcvRouteLanding from "../../../../core/src/locales/kn/lcvRouteLanding.json";
import mrLcvRouteLanding from "../../../../core/src/locales/mr/lcvRouteLanding.json";
import taLcvRouteLanding from "../../../../core/src/locales/ta/lcvRouteLanding.json";
import teLcvRouteLanding from "../../../../core/src/locales/te/lcvRouteLanding.json";

const CITY_SLUGS_BY_LOCALE: Record<string, Set<string>> = {
    bn: new Set(Object.keys((bnLcvRouteLanding as { cities?: Record<string, unknown> }).cities ?? {})),
    en: new Set(Object.keys((enLcvRouteLanding as { cities?: Record<string, unknown> }).cities ?? {})),
    gu: new Set(Object.keys((guLcvRouteLanding as { cities?: Record<string, unknown> }).cities ?? {})),
    hi: new Set(Object.keys((hiLcvRouteLanding as { cities?: Record<string, unknown> }).cities ?? {})),
    kn: new Set(Object.keys((knLcvRouteLanding as { cities?: Record<string, unknown> }).cities ?? {})),
    mr: new Set(Object.keys((mrLcvRouteLanding as { cities?: Record<string, unknown> }).cities ?? {})),
    ta: new Set(Object.keys((taLcvRouteLanding as { cities?: Record<string, unknown> }).cities ?? {})),
    te: new Set(Object.keys((teLcvRouteLanding as { cities?: Record<string, unknown> }).cities ?? {}))
};

export function getVerifiedCityHreflangLocales(slug: string, hreflangLocales: string[]) {
    const verifiedLocales = hreflangLocales.filter((locale) => CITY_SLUGS_BY_LOCALE[locale]?.has(slug));

    if (verifiedLocales.length > 0) {
        return verifiedLocales;
    }

    return CITY_SLUGS_BY_LOCALE.en?.has(slug) ? ["en"] : ["en"];
}
